import { AxiosInstance } from 'axios';
import AxiosRepository from './axios.repository';
import { IAccountRepository, IUsersListParams, UserCreationPayload } from '@common/interfaces';
import { decoupledClientInstance } from '@common/utils/axios';

class AccountRepository extends AxiosRepository implements IAccountRepository {
  public constructor(protected authClient: AxiosInstance) {
    super((decoupledClientInstance as any).create(), authClient);
  }

  async getCurrentUser() {
    const { data } = await this.get('/accounts/me/');
    return data;
  }

  async getUsers(params?: IUsersListParams) {
    const { data } = await this.get('/accounts/user-management/', { params });
    return data;
  }

  async getFilters() {
    const { data } = await this.get('/accounts/user-management/filters/');
    return data;
  }

  async createUser(payload: UserCreationPayload) {
    const { data } = await this.post('/accounts/user-management/pre-register/', payload);
    return data;
  }

  async getUserOptions() {
    const { data } = await this.get('/accounts/user-management/pre-register/options/');
    return data;
  }
}

export default AccountRepository;
